const types = {
  //AUTH
  AUTH_LOGIN: "[AUTH] Login",
  AUTH_LOGOUT: "[AUTH] Logout",
  AUTH_UPDATE_USER: "[AUTH] Update User",
  AUTH_LOADING_FINISH: "[AUTH] Loading finish",
  AUTH_RENEW_TOKEN: "[AUTH] Renew token",
  AUTH_SET_SKIP_LAST_LOGIN: "[AUTH] Set skip persist login audit",

  //ADS CAMPAIGNS
  GET_ADS_CAMPAIGNS_FINISH: "[ADS CAMPAIGNS] Get Ads Campaigns Finish",
  GET_NEXT_ADS_CAMPAIGNS__FINISH:
    "[ADS CAMPAIGNS] Get Next Ads Campaigns Finish",
  DELETE_ADS_CAMPAIGN_FINISH: "[ADS CAMPAIGNS] Delete Ads Campaign Finish",
  CLEAN_ADS_CAMPAIGNS: "[ADS CAMPAIGNS] Clean Ads Campaigns",
  SAVE_ADS_CAMPAIGN_FINISH: "[ADS CAMPAIGNS] Save Ads Campaign Finish",
  GET_ADS_CAMPAIGNS_IDS_BY_AGENCY:
    "[ADS CAMPAIGNS] Get Ads Campaigns IDs By Agency",
  GET_BASIC_DATA_ADS_CAMPAIGN: "[ADS CAMPAIGNS] Get Basic Data Ads Campaign",
  SET_PUBLISHING_CAMPAIGN_STATE:
    "[ADS CAMPAIGNS] Set Publishing Campaign State",
  CLEAR_PUBLISH_RESULT: "[ADS CAMPAIGNS] Clear Publish Result",
  GET_ADS_CAMPAIGNS_SCHEMAS: "[ADS CAMPAIGNS] Get Ads Campaigns Schemas",
  SET_ADS_CAMPAIGN_STATUS_OVERRIDE:
    "[ADS CAMPAIGNS] Set Campaign Status Override",
  REMOVE_ADS_CAMPAIGN_STATUS_OVERRIDES:
    "[ADS CAMPAIGNS] Remove Campaign Status Overrides",

  //LOCALE
  GET_LOCALES_FINISH: "[LOCALE] Get Locales Finish",
  GET_LOCALE_FINISH: "[LOCALE] Get Locale Finish",
  SET_LOCALE_FINISH: "[LOCALE] Set Locale Finish",
  LOCALE_LOADING_FINISH: "[LOCALE] Locale Loading Finish",

  //USER
  GET_FACEBOOK_INTEGRATION: "[USER] Get Facebook Integration",
  REVOKE_FACEBOOK_INTEGRATION: "[USER] Revoke Facebook Integration",
  GET_INTEGRATIONS: "[USER] Get Integrations Finish",
  SET_FACEBOOK_INTEGRATION_BUSINESS_ACCOUNTS:
    "[USER] Set Facebook integration business accounts",
  SET_FACEBOOK_INTEGRATION_PAGES: "[USER] Set Facebook integration pages",
  SET_LINKEDIN_INTEGRATION_ADVERTISERS:
    "[USER] Set LinkedIn integration advertisers",
  SET_LINKEDIN_INTEGRATION_PAGES: "[USER] Set LinkedIn integration pages",
  GET_LAST_SELECTED_INTEGRATION_DATA:
    "[USER] Get Last Selected Integration Data Finish",
  SET_LAST_SELECTED_INTEGRATION_DATA_BY_PLATFORM:
    "[USER] Set Last Selected Integration Data By Platform",
  GET_BUSINESS_NAME: "[USER] Get business name",
  GET_ADS_USERS: "[USER] Get Ads Users",
  MANAGE_USER: "[USER] Manage User",
  DELETE_USER: "[USER] Delete User",
  SET_USER_STORAGE: "[USER] Set User Storage",
  GET_CANVA_INTEGRATION: "[USER] Get Canva Integration",
  REVOKE_CANVA_INTEGRATION: "[USER] Revoke Canva Integration",
  GET_TIKTOK_BUSINESS_INTEGRATION: "[USER] Get Tiktok Business Integration",
  ADD_TIKTOK_BUSINESS_ADVERTISER: "[USER] Add Tiktok Business Advertiser",
  REVOKE_TIKTOK_BUSINESS_INTEGRATION:
    "[USER] Revoke Tiktok Business Integration",
  GET_TIKTOK_INTEGRATION: "[USER] Get Tiktok Integration",
  REVOKE_TIKTOK_INTEGRATION: "[USER] Revoke Tiktok Integration",
  GET_GOOGLE_ADS_INTEGRATION: "[USER] Get Google Ads Integration",
  REVOKE_GOOGLE_ADS_INTEGRATION: "[USER] Revoke Google Ads Integration",
  GET_LINKEDIN_ADS_INTEGRATION: "[USER] Get LinkedIn Ads Integration",
  REVOKE_LINKEDIN_ADS_INTEGRATION: "[USER] Revoke LinkedIn Ads Integration",
  GET_YOUTUBE_INTEGRATION: "[USER] Get YouTube Integration",
  REVOKE_YOUTUBE_INTEGRATION: "[USER] Revoke YouTube Integration",
  GET_GOOGLE_DRIVE_INTEGRATION: "[USER] Get Google Drive Integration",
  REVOKE_GOOGLE_DRIVE_INTEGRATION: "[USER] Revoke Google Drive Integration",
  GET_USER_IP: "[USER] Get User IP",
  CHANGE_ADVERTISER_ID_CUSTOM_CLAIM: "[USER] Change Advertiser ID Custom Claim",
  GET_IS_FREE_AI_VIDEO_GENERATED: "[USER] Get Is Free AI Video Generated",
  GET_TOTAL_METRICS_CAMPAIGNS: "[USER] Get Total Metrics Campaigns",
  GET_USER_HIDE_METRICS_ALERT: "[USER] Get User Hide Metrics Alert",
  SET_USER_HIDE_METRICS_ALERT: "[USER] Set User Hide Metrics Alert",
  SET_ADVERTISER_LANGUAGE: "[USER] Set Advertiser Language",
  RESET_ADVERTISER_LANGUAGE: "[USER] Reset Advertiser Language",

  //UI
  UI_SET_OPEN_SLIDE_MENU: "[UI] Set Open Slide Menu",
  UI_SET_SLIDE_MENU_COLLAPSED: "[UI] Set Slide Menu Collapsed",
  UI_SET_OPEN_NOTIFICATION: "[UI] Set Open Notification",
  UI_SET_SHOW_BACKDROP: "[UI] Set Show Backdrop",
  UI_SHOW_MODAL_SELECT_SUBSCRIPTION: "[UI] Show Modal Select Subscription",
  SET_VERSION: "[UI] Set Version",
  UI_SET_THEME: "[UI] Set Theme",
  SET_LAST_DATE_TIME_INSIGHTS: "[UI] Set Last DateTime Insights",
  SET_AGENCIES_FEATURE_FLAGS: "[UI] Set Agencies Feature Flags",
  RESET_UI_STATE: "[UI] Reset UI State",
  UI_SET_MODAL_OPEN_STATE: "[UI] Set Modal Open State",
  UI_SET_ADLE_CARD_WAITLIST_STATUS: "[UI] Set Adle Card Waitlist Status",
  UI_SET_NOTIFICATIONS_PANEL_IS_CLOSED:
    "[UI] Set Notifications Panel Is Closed",
  UI_SET_NOTIFICATIONS_PANEL_IS_EXPANDED:
    "[UI] Set Notifications Panel Is Expanded",
  UI_SET_NOTIFICATIONS_PREVIOUS_NOTIFICATIONS:
    "[UI] Set Notifications Previous Notifications",

  //ALERTS
  ALERTS_SHOW_MODAL_INTEGRATION_NOT_FOUND:
    "[ALERTS] Show Modal Integration Not Found",
  ALERTS_SET_INTEGRATIONS_NOT_FOUND: "[ALERTS] Set Integrations Not Found",
  ALERTS_RESET_INTEGRATION_NOT_FOUND: "[ALERTS] Reset Integration Not Found",
  ALERTS_SET_PENDING_INTEGRATION_FORM_SYNC:
    "[ALERTS] Set Pending Integration Form Sync",
  ALERTS_CONSUME_PENDING_INTEGRATION_FORM_SYNC_FOR_CAMPAIGN:
    "[ALERTS] Consume Pending Integration Form Sync For Campaign",
  // New notification types for extensible alerts system
  ALERTS_ADD_NOTIFICATION: "[ALERTS] Add Notification",
  ALERTS_UPDATE_NOTIFICATION: "[ALERTS] Update Notification",
  ALERTS_REMOVE_NOTIFICATION: "[ALERTS] Remove Notification",
  ALERTS_CLEAR_ALL_NOTIFICATIONS: "[ALERTS] Clear All Notifications",
  ALERTS_SYNC_CREATIVE_JOB_NOTIFICATIONS:
    "[ALERTS] Sync Creative Job Notifications",
  ALERTS_SYNC_GLOBAL_NOTIFICATIONS: "[ALERTS] Sync Global Notifications",
  ALERTS_PENDING_READ_GLOBAL_NOTIFICATIONS:
    "[ALERTS] Pending Read Global Notifications",
  ALERTS_CLEAR_PENDING_READ_GLOBAL_NOTIFICATIONS:
    "[ALERTS] Clear Pending Read Global Notifications",
  ALERTS_PENDING_DISMISS_GLOBAL_NOTIFICATION:
    "[ALERTS] Pending Dismiss Global Notification",
  ALERTS_CLEAR_PENDING_DISMISS_GLOBAL_NOTIFICATION:
    "[ALERTS] Clear Pending Dismiss Global Notification",
  ALERTS_PROMOTE_CREATIVE_NOTIFICATION:
    "[ALERTS] Promote Creative Notification",

  //PLANS AND PAYMENTS
  GET_PLANS_FINISH: "[PAYMENTS] Get Plans Finish",
  GET_PAYMENTS_FINISH: "[PAYMENTS] Get Payments Finish",
  LOADING_PAYMENTS_FINISH: "[PAYMENTS] Loading Payments Finish",
  GET_STRIPE_INFO_FINISH: "[PAYMENTS] Get Stripe Info Finish",
  SET_CUSTOMER_ID: "[PAYMENTS] Set Customer ID",
  SET_DEFAULT_PAYMENT_METHOD: "[PAYMENTS] Get Default Payment Method Finish",
  PAY_SUBSCRIPTION: "[PAYMENTS] Pay Subscription",
  CHANGE_SUBSCRIPTION_ADS: "[PAYMENTS] Change Subscription Ads",
  SET_PRORATED_PRICE_PLANS: "[PAYMENTS] Set Prorated Price Plans",
  PAY_INVOICE: "[PAYMENT] Pay Invoice",
  GET_SUBSCRIPTION_PLAN: "[PAYMENTS] Get Subscription Plan",
  GET_SUBSCRIPTION_PLAN_INFO: "[PAYMENTS] Get Subscription Plan Info",
  GET_SUBSCRIPTION_PLAN_INFO_USAGE:
    "[PAYMENTS] Get Subscription Plan Info Usage",
  GET_BRAND_USAGE_ALLOCATION: "[PAYMENTS] Get Brand Usage Allocation",
  GET_BRAND_USAGE_CONSUMED: "[PAYMENTS] Get Brand Usage Consumed",
  SET_IS_ACTIVE_PLAN: "[PAYMENTS] Set Is Active Plan",
  SET_IS_PLAN_ACTIVE_RESOLVED: "[PAYMENTS] Set Is Plan Active Resolved",
  SET_TYPE_OF_PLANS: "[PAYMENTS] Set Type Of Plans",
  SET_LINKEDIN_POST_SHARED: "[PAYMENTS] Set LinkedIn Post Shared",
  PAY_SUBSCRIPTION_ADS: "[PAYMENTS] Pay Subscription Ads",
  CANCEL_SUBSCRIPTION: "[PAYMENTS] Cancel Subscription",
  REACTIVATE_SUBSCRIPTION: "[PAYMENTS] Reactivate Subscription",
  UPDATE_PLAN_STATUS: "[PAYMENTS] Update Plan Status",
  SET_TRIAL_ACTIVE: "[PAYMENTS] Set Trial Active",
  SET_PRORATION_PRICES: "[PAYMENTS] Set Proration Prices",
  SET_LOADING_PRORATION_PRICES: "[PAYMENTS] Set Loading Proration Prices",
  CLEAR_PRORATION_PRICES: "[PAYMENTS] Clear Proration Prices",
  SET_CREDIT_ACTION_COSTS: "[PAYMENTS] Set Credit Action Costs",
  SET_BYOK_CONFIGURATION_PUBLIC: "[PAYMENTS] Set BYOK Configuration Public",
  SET_BYOK_CONFIGURATION_LOADING: "[PAYMENTS] Set BYOK Configuration Loading",

  //CHAT
  OPEN_CHAT: "[CHAT] Open Chat",
  CLOSE_CHAT: "[CHAT] Close Chat",
  SET_CHATS: "[CHAT] Set Chats",
  SET_CURRENT_WRITE_MESSAGE: "[CHAT] Set Current Write Message",
  SET_CHATS_MESSAGES: "[CHAT] Set Chats Messages",
  SET_CURRENT_CHAT: "[CHAT] Set Current Chat",
  SET_CURRENT_CHAT_MESSAGES: "[CHAT] Set Current Chat Messages",
  SET_IS_TYPING_BOT: "[CHAT] Set Is Typing Bot",
  SET_IS_OPEN_CHAT: "[CHAT] Set Is Open Chat",
  MARK_READ_CHAT: "[CHAT] Mark Read Chat",
  MARK_DISABLED_CHAT: "[CHAT] Mark Disabled Chat",
  SET_NEW_CHAT: "[CHAT] Set New Chat",
  SET_UPLOADING_FILE: "[CHAT] Set Uploading File",
  CLEAR_TEMPORARY_CHATS: "[CHAT] Clear Temporary Chats",
  ADD_MESSAGE_CHAT: "[CHAT] Add Message Chat",
  ADD_MESSAGES_CHAT: "[CHAT] Add Messages Chat",
  ADD_MESSAGE_CHAT_IN_LIST: "[CHAT] Add Message Chat In List",

  //GLOBAL TYPES
  GLOBAL_RESET_STATE: "[GLOBAL] Reset State",
  GLOBAL_RESET_ADVERTISER_DATA: "[GLOBAL] Reset Advertiser data",

  //NPS
  SHOW_NPS_FORM: "[NPS] Show NPS Form",
  HIDE_NPS_FORM: "[NPS] Hide NPS Form",

  //OWNER
  GET_OWNER_BASIC_DATA: "[OWNER] Get Owner Basic Data",
  GET_ADVERTISER_STATS: "[OWNER] Get Advertiser Stats",
  GET_GLOBAL_METRICS: "[OWNER] Get Global Metrics",
  UPDATE_ADVERTISER: "[OWNER] Update Advertiser",
  GET_ADVERTISER_ACTIVITY_REPORT: "[OWNER] Get Advertiser Activity Report",
  GET_ADVERTISER_ACTIVE_CAMPAIGNS: "[OWNER] Get Advertiser Active Campaigns",
  GET_ADVERTISER_OPTIMIZATIONS: "[OWNER] Get Advertiser Optimizations",
  GET_AGENCY_ACTIVE_USERS: "[OWNER] Get Agency Active Users",
  GET_ADVERTISERS: "[OWNER] Get Advertisers",
  GET_NEXT_ADVERTISERS: "[OWNER] Get Next Advertisers",

  // CREATIVE TEMPLATES
  CREATIVE_TEMPLATES_HIDE_PENDING_DELETE:
    "[CREATIVE TEMPLATES] Hide Pending Delete",
  CREATIVE_TEMPLATES_CLEAR_PENDING_DELETE:
    "[CREATIVE TEMPLATES] Clear Pending Delete",
  CREATIVE_TEMPLATES_PRUNE_PENDING_DELETES:
    "[CREATIVE TEMPLATES] Prune Pending Deletes",

  // VIDEO EDITOR
  VIDEO_EDITOR_INIT_PROJECT: "[VIDEO EDITOR] Init Project",
  VIDEO_EDITOR_RESET: "[VIDEO EDITOR] Reset",
  VIDEO_EDITOR_SET_PLAYHEAD: "[VIDEO EDITOR] Set Playhead",
  VIDEO_EDITOR_COMMIT_CLIP_UPDATE: "[VIDEO EDITOR] Commit Clip Update",
  VIDEO_EDITOR_SPLIT_CLIP_AT_PLAYHEAD: "[VIDEO EDITOR] Split Clip At Playhead",
  VIDEO_EDITOR_ADD_CLIP: "[VIDEO EDITOR] Add Clip",
  VIDEO_EDITOR_REMOVE_CLIP: "[VIDEO EDITOR] Remove Clip",
  VIDEO_EDITOR_SET_EXPORTING: "[VIDEO EDITOR] Set Exporting",
  VIDEO_EDITOR_MARK_SAVED: "[VIDEO EDITOR] Mark Saved",
  VIDEO_EDITOR_SET_SELECTED_CLIP: "[VIDEO EDITOR] Set Selected Clip",
  VIDEO_EDITOR_SET_SELECTION: "[VIDEO EDITOR] Set Selection",
  VIDEO_EDITOR_COMMIT_CLIP_UPDATES: "[VIDEO EDITOR] Commit Clip Updates",
  VIDEO_EDITOR_REMOVE_CLIPS: "[VIDEO EDITOR] Remove Clips",
  VIDEO_EDITOR_APPLY_EDL: "[VIDEO EDITOR] Apply EDL",
};

export default types;
